import {requirePermission} from '@/modules/auth/permissions'
import {PatientForm} from '@/modules/patients/components/patient-form/patient-form'
import {useManualEntryBlocked} from '@/shared/hooks/use-manual-entry-flags'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute, redirect} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/patient-dashboard/patients/new')({
  beforeLoad: requirePermission('patients.edit'),
  component: RouteComponent,
})

function RouteComponent() {
  const {t} = useTranslate('patient')
  const {manualPatientsBlocked} = useManualEntryBlocked()
  if (manualPatientsBlocked) throw redirect({to: '/patient-dashboard/patients'})

  return (
    <NewResourceFormContainer px="4">
      <NewResourceFormHeader title={t('new_patient_title')} description={t('new_patient_description')} />
      <PatientForm />
    </NewResourceFormContainer>
  )
}
